import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CustomerOverviewModel, SubTitleWrapper } from 'src/app/classes';
import * as moment from 'moment';

@Component({
  selector: 'app-customer-preview',
  templateUrl: './customer-preview.component.html',
  styleUrls: ['./customer-preview.component.css']
})
export class CustomerPreviewComponent implements OnChanges, OnInit {

  @Input() customer: CustomerOverviewModel;

  customerPreview: string = "";
  subTitles: SubTitleWrapper[] = [];

  constructor() { }

  ngOnChanges(simpleChanges: SimpleChanges): void {
    if(simpleChanges['customer']) this.updateCustomer();
  }

  ngOnInit(): void {
    this.updateCustomer();
  }

  updateCustomer(){
    this.subTitles = [];
    this.customerPreview = `${this.customer.customernumber} ${this.customer.customername}`;
    if(this.customer.accessed) this.subTitles.push({ type: "Verwendet", value: moment(this.customer.accessed).format("DD.MM.YYYY HH:mm:ss") });
    if(this.customer.customerfax) this.subTitles.push({ value: this.customer.customerfax, type: "Fax" } as SubTitleWrapper);
    if(this.customer.customermail) this.subTitles.push({ value: this.customer.customermail, type: "E-Mail" } as SubTitleWrapper);
    if(this.customer.customerphone) this.subTitles.push({ value: this.customer.customerphone, type: "Telefon" } as SubTitleWrapper);
  }

}
